import { displayDateFormatter } from "components/helpers";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import store from "../redux/store";

dayjs.extend(utc);
dayjs.extend(timezone);

export const DATE_FORMAT = "MMM DD, YYYY";
export const DATE_TIME_FORMAT = "MMM DD, YYYY hh:mm a";

export const trimmedDate = (date) => {
  if (date) {
    return date.split(" 00:00:00 GMT")[0];
  } else {
    return "N/A";
  }
};

export const formatText = (value) => {
  if (!value) return "";
  return value
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const getFormattedDate = (dateInput) => {
  if (!dateInput) return "-";
  const state = store.getState();

  const timezoneToUse = state.practice.practiceTimezone;

  const parsedDate = new Date(dateInput);

  return dayjs.utc(parsedDate).tz(timezoneToUse).format(DATE_FORMAT);
};

export const getFormattedDateTime = (dateInput) => {
  if (!dateInput) return "-";
  const state = store.getState();

  const timezoneToUse = state.practice.practiceTimezone;
  const parsedDate = new Date(dateInput);

  return dayjs.utc(parsedDate).tz(timezoneToUse).format(DATE_TIME_FORMAT);
};

export const getFormattedDateNoTz = (dateInput) => {
  if (!dateInput) return "-";

  return dayjs(dateInput).format(DATE_FORMAT);
};

// @time : "9:00 PM" or "9:00 AM"
export const time24Hours = (time) => {
  const [t, a] = time.split(" ");
  let [hr, min] = t.split(":");
  if (a.toLowerCase() === "am") {
    return `${hr}:${min}`;
  }
  if (a.toLowerCase() === "pm") {
    return `${parseInt(hr) + 12}:${min}`;
  }
};

export const getMimeType = (ext, default_ = "application/pdf") => {
  return (
    {
      png: "image/png",
      jpeg: "image/jpeg",
      jpg: "image/jpg",
      pdf: "application/pdf",
    }[ext] || default_
  );
};

export const totalCheckedInTime = (startTime, endTime) => {
  try {
    if (!startTime || !endTime) return "N/A";
    let [startHr, startMin] = time24Hours(startTime).split(":");
    let [endHr, endMin] = time24Hours(endTime).split(":");
    let totalHr = endHr - startHr;
    let totalMin = endMin - startMin;
    if (totalMin < 0) {
      totalMin = 60 + totalMin;
      totalHr--;
    }
    return `${totalHr}:${totalMin}`;
  } catch (error) {
    console.log("error totalCheckedInTime:  ", error);
    return "N/A";
  }
};

export const states = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "American Samoa", value: "AS" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Northern Mariana Isla", value: "MP" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virgin Islands", value: "VI" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "Washington D.C.", value: "DC" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const timeZoneArray = ["EST", "CST"];

export const updatedFields = (touchedFields, dataFields) => {
  return Object.keys(dataFields).reduce((acc, curr) => {
    if (touchedFields[curr]) acc[curr] = dataFields[curr];
    return acc;
  }, {});
};

export const providerTypesArray = [
  { label: "Individual", value: "Individual" },
  { label: "Organization", value: "Organization" },
];

function convertHtmlToPlainText(htmlString) {
  const parser = new DOMParser();
  const parsedDoc = parser.parseFromString(htmlString, "text/html");

  function getTextContent(node) {
    let text = "";

    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        text += child.textContent;
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        if (child.tagName === "BR") {
          text += "\n";
        } else if (child.tagName === "P" || child.tagName === "DIV") {
          text += getTextContent(child) + "\n"; // Add line break for paragraphs
        } else {
          text += getTextContent(child);
        }
      }
    });

    return text;
  }

  return getTextContent(parsedDoc.body).trim();
}

export const printDictationPDF = (data, userData = {}) => {
  const doc = new jsPDF();
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const margin = 10;
  const titleHeight = 20;
  const lineSpacing = 10;
  let yPosition = margin;
  // Title
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("Patient Evaluation Report", pageWidth / 2, yPosition, {
    align: "center",
  });
  yPosition += titleHeight;

  data.map((record) => {
    const {
      practice_details: practiceDetails,
      patient_details: patientDetails,
    } = record;

    // Practice Information Header
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");

    // Practice Information Details
    const practiceInfoLines = [
      `${practiceDetails.practice_name}`,
      ...(userData.email === "Jaijalaj@yahoo.com"
        ? doc.splitTextToSize(
            `${practiceDetails.information}`,
            pageWidth - 8 * margin
          )
        : []),
    ];

    practiceInfoLines.forEach((line, index) => {
      doc.setFontSize(12);
      if (index === 0) {
        doc.setFont("helvetica", "bold");
      } else {
        doc.setFont("helvetica", "normal");
      }

      doc.text(line, pageWidth / 2, yPosition, { align: "center" });
      yPosition += 6;
    });

    const practiceOtherInfo = [
      `${practiceDetails.address_line1} ${practiceDetails.address_line2}`,
      `${practiceDetails.city}, ${practiceDetails.state_cd} ${practiceDetails.zip_code}`,
      `Tel: ${practiceDetails.phone} / Fax: ${practiceDetails.fax}`,
      `Tax Id: ${practiceDetails.tax_id}`,
    ];

    practiceOtherInfo.forEach((line) => {
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(line, pageWidth / 2, yPosition + 4, { align: "center" });
      yPosition += 6;
    });

    // Patient Information
    yPosition += lineSpacing;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Patient Information", margin, yPosition);
    yPosition += lineSpacing;

    doc.setFont("helvetica", "normal");
    doc.text(
      `Name: ${patientDetails?.first_name || "N/A"} ${
        patientDetails?.last_name || ""
      }`,
      margin,
      yPosition
    );
    yPosition += lineSpacing;
    doc.text(
      `DOB: ${
        patientDetails?.dob ? displayDateFormatter(patientDetails?.dob) : "N/A"
      }`,
      margin,
      yPosition
    );
    yPosition += lineSpacing;
    doc.text(
      `Date of Evaluation: ${
        record.dos ? displayDateFormatter(record.dos) : "N/A"
      }`,
      margin,
      yPosition
    );

    // Clinical Note Summary Header
    yPosition += lineSpacing * 2;
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Clinical Note Summary", pageWidth / 2, yPosition, {
      align: "center",
    });
    yPosition += lineSpacing;

    // Notes Section
    record.notes.forEach((note) => {
      const lineSpacing = 7;

      // Set font and add note category
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text(`${note.note_category}`, margin, yPosition);

      yPosition += 6;

      // Set font for note text
      doc.setFont("helvetica", "normal");

      // Check if note.text is HTML

      let noteTextToRender = note.note_text;

      // If the note text is HTML, we convert it to plain text while maintaining format
      if (isHTML(note.note_text)) {
        noteTextToRender = convertHtmlToPlainText(note.note_text);
      }

      // Wrap the note text to fit within the page width
      const wrappedText = doc.splitTextToSize(
        noteTextToRender,
        doc.internal.pageSize.width - 2 * margin
      );

      // Render each line of wrapped text and adjust yPosition
      wrappedText.forEach((line) => {
        doc.text(line, margin, yPosition);
        yPosition += lineSpacing;

        // Check if content exceeds page height
        if (yPosition >= pageHeight - margin) {
          doc.addPage();
          yPosition = margin;
        }
      });

      yPosition += lineSpacing;
    });

    // Closing Statement
    yPosition += lineSpacing;
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(
      "Thank you for allowing me to evaluate this patient.",
      margin,
      yPosition
    );
    yPosition += lineSpacing * 2;
    doc.text("Sincerely,", margin, yPosition);
    yPosition += lineSpacing;
    doc.text(practiceDetails.practice_name, margin, yPosition);

    // Footer with Gray Text
    doc.setFontSize(10);
    doc.setTextColor(150, 150, 150);
    // Page Number
    doc.setTextColor(0, 0, 0);
    const pageCount = doc.internal.getNumberOfPages();
    doc.text(
      `Page ${pageCount} of ${pageCount}`,
      pageWidth - 50,
      pageHeight - 10
    );
  });

  // Generate the Blob and Open in New Tab
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};

export const isHTML = (str) => {
  const doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};
